import { SelectAssessment } from './Select';

export const AssessmentType = {
  Select: SelectAssessment,
};
